<header class="sticky top-0 z-50 bg-white shadow-sm">
  <!-- Top bar -->
  <div class="bg-primary text-primary-foreground">
    <div class="container mx-auto px-4 py-2 flex justify-between items-center">
      <div class="flex gap-6 text-sm">
        @if (company()?.email) {
          <span>📧 {{ company()?.email }}</span>
        }
        @if (company()?.phoneNumber) {
          <a [href]="whatsappUrl()" target="_blank" class="flex items-center">
            <span>📞 {{ company()?.phoneNumber }}</span>
          </a>
        }
      </div>
      <div class="flex gap-4 text-sm">
        @if (whatsappUrl()) {
          <a
            [href]="whatsappUrl()"
            target="_blank"
            class="hover:text-secondary transition-colors"
            >Ayuda</a
          >
        }
        <!-- <a href="#" class="hover:text-secondary transition-colors">Seguimiento</a> -->
      </div>
    </div>
  </div>

  <!-- Main header -->
  <div class="container mx-auto px-4 py-4">
    <div class="flex items-center justify-between gap-8">
      <!-- Logo -->
      <div class="flex-shrink-0">
        <a routerLink="/" class="block">
          @if (company()?.logoUrl) {
            <img [src]="company()?.logoUrl" alt="Logo" class="h-16 w-auto" />
          }
        </a>
      </div>

      <!-- Search bar (desktop) -->
      <div class="hidden md:block flex-1 max-w-2xl">
        <div class="relative">
          <input
            appInput
            type="text"
            placeholder="Buscar repuestos..."
            class="h-12 rounded-full border-2 border-gray-200"
            [ngModel]="searchTerm()"
            (ngModelChange)="onSearch($event)"
            (keydown.enter)="triggerSearch()"
          />
          <button
            appButton
            variant="secondary"
            class="absolute right-1 top-1/2 -translate-y-1/2 rounded-full h-10 w-10 p-0"
            (click)="triggerSearch()"
          >
            <mat-icon>search</mat-icon>
          </button>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-4">
        <!-- User -->
        @if (isAuthenticated()) {
          <button
            appButton
            variant="ghost"
            class="relative flex items-center gap-2 h-auto px-3 py-2"
            [matMenuTriggerFor]="userMenu"
          >
            <div
              class="h-8 w-8 rounded-full bg-secondary text-white text-sm font-semibold flex items-center justify-center shrink-0"
            >
              {{ getInitials(user()?.firstName, user()?.lastName) }}
            </div>
            <mat-icon class="text-gray-500 !m-0 !size-4 !text-[16px]">
              expand_more
            </mat-icon>
          </button>

          <mat-menu #userMenu="matMenu" xPosition="before" class="mt-2 text-sm">
            <div class="px-4 py-3 min-w-48">
              <p class="font-medium text-foreground truncate">
                {{ user()?.firstName }} {{ user()?.lastName }}
              </p>
              <p class="text-xs text-muted-foreground truncate">
                {{ user()?.email }}
              </p>
            </div>
            <mat-divider />
            <a mat-menu-item routerLink="/user/profile">
              <mat-icon>account_circle</mat-icon>
              <span>Mi Perfil</span>
            </a>
            <a mat-menu-item routerLink="/user/addresses">
              <mat-icon>location_on</mat-icon>
              <span>Mis Direcciones</span>
            </a>
            <a mat-menu-item routerLink="/user/orders">
              <mat-icon>inventory_2</mat-icon>
              <span>Mis Pedidos</span>
            </a>
            <mat-divider />
            <button
              mat-menu-item
              (click)="onLogout()"
              class="!text-destructive group"
            >
              <mat-icon class="group-hover:text-destructive">logout</mat-icon>
              <span>Cerrar Sesión</span>
            </button>
          </mat-menu>
        } @else {
          <button
            appButton
            variant="ghost"
            class="flex items-center gap-2"
            (click)="onLogin()"
          >
            <mat-icon>person</mat-icon>
            <span class="hidden sm:inline">Iniciar Sesión</span>
          </button>
        }

        <!-- Cart -->
        <button
          appButton
          variant="ghost"
          size="icon"
          class="relative"
          (click)="toggleCart()"
        >
          <mat-icon>shopping_cart</mat-icon>
          @if (totalItems() > 0) {
            <span
              class="absolute -top-1 -right-1 bg-secondary text-white text-xs rounded-full h-5 w-5 flex items-center justify-center"
            >
              {{ totalItems() }}
            </span>
          }
        </button>

        <app-theme-selector />

        <!-- Mobile Menu Toggle -->
        <button
          appButton
          variant="ghost"
          size="icon"
          class="md:!hidden"
          [matMenuTriggerFor]="mobileMenu"
        >
          <mat-icon>menu</mat-icon>
        </button>

        <mat-menu #mobileMenu="matMenu">
          <a mat-menu-item routerLink="/">
            <mat-icon>home</mat-icon>
            <span>Inicio</span>
          </a>
          <a mat-menu-item routerLink="/catalog">
            <mat-icon>directions_car</mat-icon>
            <span>Catálogo</span>
          </a>
        </mat-menu>
      </div>
    </div>

    <!-- Search bar (mobile) -->
    <div class="mt-3 md:hidden">
      <div class="relative">
        <input
          appInput
          type="text"
          placeholder="Buscar repuestos..."
          class="h-12 rounded-full border-2 border-gray-200"
          [ngModel]="searchTerm()"
          (ngModelChange)="onSearch($event)"
          (keydown.enter)="triggerSearch()"
        />
        <button
          appButton
          variant="secondary"
          class="absolute right-1 top-1/2 -translate-y-1/2 rounded-full h-10 w-10 p-0"
          (click)="triggerSearch()"
        >
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>
  </div>
</header>
